const axios = require('axios')
const qs = require('qs')

const URL = process.env.STRAPI_URL_SUYJ
async function authorizeStrapi() {
  console.log('authorize strapi')
  const authUrl = `${URL}/auth/local`
  const auth = await axios.post(authUrl, {
    identifier: process.env.STRAPI_USERNAME_SUYJ,
    password: process.env.STRAPI_PASSWORD_SUYJ,
  })
  if (auth.status === 200) {
    console.log('authorized')
    return { Authorization: `Bearer ${auth.data.jwt}`, 'Content-Type': 'application/json' }
  }
  return false
}


class StrapiV3 {
  constructor() {
    this.strapi = null
    this.productsBySku = {}
  }

  async init() {
    if (this.strapi) return this.strapi
    this.strapi = await authorizeStrapi()
    return this.strapi
  }

  async post(path, { data }) {
    path = path.replace('/form-submissions', '/form-entries')
    data.entry_uid = data.entry_uid || data.uid
    if (!this.strapi) await this.init()
    const url = `${URL}${path}`
    console.log(`Posting to ${url}`)
    let apiResponse
    try {
      apiResponse = await axios.post(url, data, { headers: this.strapi })
    } catch (err) {
      this.reportError(err, `Error posting to ${url} data: ${JSON.stringify(data, null, 2)}`)
      apiResponse = err.response
    }
    return apiResponse
  }

  async put(path, { data }) {
    path = path.replace('/form-submissions', '/form-entries')
    if (!this.strapi) await this.init()
    const url = `${URL}${path}`
    if(data.submitted) {
      data.submited = true
    }
    let apiResponse
    try {
      apiResponse = await axios.put(url, data, { headers: this.strapi })
    } catch (err) {
      this.reportError(err, `Error putting to ${url} data: ${JSON.stringify(data, null, 2)}`)
      apiResponse = err.response
    }
    return apiResponse
  }

  hasData(apiResponse) {
    if (apiResponse.status === 200 && apiResponse.data && apiResponse.data[0]) {
      return true
    }
    return false
  }

  getData(apiResponse) {
    if (apiResponse.status === 200 && apiResponse.data && apiResponse.data[0]) {
      apiResponse.data[0].attributes = apiResponse.data[0]
      return apiResponse.data[0]
    }
    return false
  }

  async get(path, data) {
    path = path.replace('/form-submissions', '/form-entries')
    if (!this.strapi) await this.init()
    let qsArgs = {}
    if(data.filters && data.filters.uid) {
      qsArgs = { entry_uid: data.filters.uid }
    }
    const url = `${URL}${path}?${qs.stringify(qsArgs)}`
    console.log(`Getting from ${url}`)
    let apiResponse
    try {
      apiResponse = await axios.get(url, { headers: this.strapi })
      console.log('Got response', apiResponse.data, apiResponse.status)
    } catch (err) {
      console.log('Error getting from Strapi')
      // if (path.indexOf('/url-alias/get') === -1) {
      this.reportError(err, `Error getting ${url}`)
      // }
      apiResponse = err.response
    }
    if (apiResponse.status === 200 && apiResponse.data && apiResponse.data[0]) {
      apiResponse.data[0].attributes = apiResponse.data[0]
    }
    return apiResponse
  }
}
const BUYING_FORM = 'GrayAndSons.com Buying Form'

module.exports = { StrapiV3, authorizeStrapi, BUYING_FORM }
